import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import * as React from 'react';
import { useCallback, useMemo } from 'react';

import { useLanguage } from '../../provider/LanguageProvider';
import { immersightGrey } from '../../utils/colors';
import FlagIcon from './FlagIcon';

const useStyles = makeStyles((theme) => ({
  select: {
    display: 'flex !important',
    alignItems: 'center',
    color: `${immersightGrey} !important`,
  },
  menuItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: `${immersightGrey} !important`,
  },
  label: {
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
  },
  box: {
    paddingLeft: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
}));

const languageOptions = [
  { code: 'cs', label: 'CZ', flag: 'CZ' },
  { code: 'de', label: 'DE', flag: 'DE' },
  { code: 'en', label: 'EN', flag: 'USGB' },
  { code: 'es', label: 'ES', flag: 'ES' },
  { code: 'fr', label: 'FR', flag: 'FR' },
  { code: 'hr', label: 'HR', flag: 'HR' },
  { code: 'it', label: 'IT', flag: 'IT' },
  { code: 'ja', label: 'JP', flag: 'JP' },
  { code: 'nl', label: 'NL', flag: 'NL' },
  { code: 'pl', label: 'PL', flag: 'PL' },
  { code: 'pt', label: 'PT', flag: 'PT' },
  { code: 'ro', label: 'RO', flag: 'RO' },
  { code: 'ru', label: 'RU', flag: 'RU' },
  { code: 'sr', label: 'RS', flag: 'RS' },
  { code: 'tr', label: 'TR', flag: 'TR' },
];

const LanguagePicker = () => {
  const { locale, setLocale } = useLanguage();
  const classes = useStyles();

  const handleLanguageChange = useCallback((event: SelectChangeEvent) => {
    setLocale(event.target.value);
  }, [setLocale]);

  const menuItems = useMemo(() => languageOptions.map(({ code, label, flag }) => (
    <MenuItem key={code} value={code} className={classes.menuItem}>
      <FlagIcon code={flag}/>
      <Typography variant="body1" className={classes.label}>{label}</Typography>
    </MenuItem>
  )), [classes]);

  return (
    <Box className={classes.box}>
      <Select
        value={locale} // Use the global locale directly
        onChange={handleLanguageChange}
        classes={{
          select: classes.select,
        }}
        sx={{
          '.MuiOutlinedInput-notchedOutline': { border: 0 },
          display: "flex !important",
          alignItems: "center"
        }}
      >
        {menuItems}
      </Select>
    </Box>
  );
};

export default LanguagePicker;
